import { Router } from '@angular/router';
import { SessionsServiceConfig } from '../lib/services/sessions.service';
import { inject, Injectable } from '@angular/core';
import { SessionSignInFlag } from '../lib/components/session-signin/session-signin.component';
import AmplifyCognitoAuthProvider from '../lib/services/auth-providers/cognito.provider';
import { AmplifyAuthGrantType } from '../lib/services/auth-providers/amplify-grant-types/authorization-code.grant-type';
import { environment } from '../../../../environment/environment';

/* Define your session/user model here, it will encapsulate info about the active sessions */
interface User {
  id: string;
  username: string;
  imageSrc: string;
}

/* Set this type to your session model */
export type SessionClaims = { [key: string]: any } & User;

@Injectable({ providedIn: 'root' })
export class SessionsServiceConfigProvider {
  private router: Router = inject(Router);

  public constructor() {}

  public getConfig(): SessionsServiceConfig {
    return {
      autoRefreshCredentials: true,
      persistSessions: true,
      onSelectionRequired: () =>
        this.router.navigate(['session', 'select'], { queryParams: { flags: SessionSignInFlag.SessionRequired } }),
      onSignInRequired: (session) =>
        this.router.navigate(['session', 'signin'], {
          queryParams: { prefill_session: session.id, flags: SessionSignInFlag.SignInRequired },
        }),
      onSessionActivated: (session) => {
        const targetRoute = session.redirectTo(session.sessionInfo['role']);
        this.router.navigateByUrl(targetRoute);
      },
      sessionDiscriminator: (session) => session.id,
      authProviders: [
        new AmplifyCognitoAuthProvider('cognito', {
          label: 'Cognito',
          icon: 'pi pi-globe',
          grantType: new AmplifyAuthGrantType(),
          userPoolId: environment.cognito.userPoolId,
          userPoolWebClientId: environment.cognito.userPoolWebClientId,
          extractSessionIdFromToken: async (_, id_token) => id_token!.sub!,
          redirectTo: () => '/app',
        }),
      ],
    } as SessionsServiceConfig;
  }
}
